<div class="table-container">
  <table mat-table [dataSource]="gateways" matSort matSortActive="location" matSortDirection="asc">
    <ng-container matColumnDef="online">
      <th mat-header-cell *matHeaderCellDef
          mat-sort-header="online">{{'gateway-table.header.online-status' | translate}}</th>
      <td mat-cell *matCellDef="let gateway">
        <mat-icon *ngIf="gateway.online" class="wifi-on">wifi</mat-icon>
        <mat-icon *ngIf="!gateway.online" class="wifi-off">wifi_off</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef
          mat-sort-header="location">{{'gateway-table.header.location' | translate}}</th>
      <td mat-cell *matCellDef="let gateway"> {{gateway.location}} </td>
    </ng-container>

    <ng-container matColumnDef="gatewaySerial">
      <th mat-header-cell *matHeaderCellDef
          mat-sort-header="gatewaySerial">{{'gateway-table.header.id' | translate}}</th>
      <td mat-cell *matCellDef="let gateway">
        <a *ngIf="false; else elseLink" target="_blank"
           href="https://app.iot.eon.com/tenants/{{tenant}}/gateways/{{gateway.gatewaySerial}}">{{gateway.gatewaySerial}}
        </a>
        <ng-template #elseLink>{{gateway.gatewaySerial}}</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="osVersion">
      <th mat-header-cell *matHeaderCellDef
          mat-sort-header="osVersion">{{'gateway-table.header.os-version' | translate}}</th>
      <td mat-cell *matCellDef="let gateway">
        <eis-gateway-gateway-os-version [gateway]="gateway" [latestOsVersion]="imageOsVersions.osVersion" [isAdmin]="isAdmin"></eis-gateway-gateway-os-version>
      </td>
    </ng-container>

    <ng-container matColumnDef="imageVersion">
      <th mat-header-cell *matHeaderCellDef
          mat-sort-header="imageVersion">{{'gateway-table.header.image-version' | translate}}</th>
      <td mat-cell *matCellDef="let gateway">
        <eis-gateway-gateway-image-version [gateway]="gateway" [latestImageOSVersion]="imageOsVersions" [isAdmin]="isAdmin"></eis-gateway-gateway-image-version>
      </td>
    </ng-container>

    <ng-container matColumnDef="lastContact">
      <th mat-header-cell *matHeaderCellDef
          mat-sort-header="lastContact">{{'gateway-table.header.last-contact' | translate}}</th>
      <td mat-cell *matCellDef="let gateway"> {{gateway.lastContact | date:'dd.MM.yyyy HH:mm'}} </td>
    </ng-container>

    <ng-container matColumnDef="lastUpdated">
      <th mat-header-cell *matHeaderCellDef
          mat-sort-header="lastUpdated">{{'gateway-table.header.last-updated' | translate}}</th>
      <td mat-cell *matCellDef="let gateway"> {{gateway.lastUpdated | date:'dd.MM.yyyy HH:mm'}} </td>
    </ng-container>

    <ng-container matColumnDef="detailsAction">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions"></th>
      <td mat-cell *matCellDef="let gateway" (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu" (menuOpened)="menuOpened(true)" (menuClosed)="menuOpened(false)"
          [matMenuTriggerData]="{gw: gateway}">
        <mat-icon class="clickable">more_vert</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef
          mat-sort-header="type">{{'gateway-table.header.type' | translate}}</th>
      <td mat-cell *matCellDef="let gateway">{{ gateway.type}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row (click)="routeToDetails(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<mat-menu #menu="matMenu">
  <ng-template matMenuContent let-gw=gw>
    <a mat-menu-item target="_blank" href="https://app.iot.eon.com/tenants/{{gw.tenant}}/gateways/{{gw.gatewaySerial}}"
       [disabled]="!gw.online">
      <mat-icon svgIcon="link-external"></mat-icon>
      {{'gateway-table.popupmenu.eiot' | translate}}
    </a>

    <a mat-menu-item target="_blank"
       href="https://dashboard.iot.eon.com/explore?schemaVersion=1&panes=%7B%22p6q%22%3A%7B%22datasource%22%3A%224R0FaDQVk%22%2C%22queries%22%3A%5B%7B%22refId%22%3A%22A%22%2C%22expr%22%3A%22%7Bdevice_id%3D%5C%22{{gw.gatewaySerial}}%5C%22%7D+%7C%3D+%60%60%22%2C%22queryType%22%3A%22range%22%2C%22datasource%22%3A%7B%22type%22%3A%22loki%22%2C%22uid%22%3A%224R0FaDQVk%22%7D%2C%22editorMode%22%3A%22builder%22%2C%22direction%22%3A%22backward%22%7D%5D%2C%22range%22%3A%7B%22from%22%3A%22now-1h%22%2C%22to%22%3A%22now%22%7D%2C%22compact%22%3Afalse%7D%7D&orgId=63574">
      <mat-icon svgIcon="link-external"></mat-icon>
      {{'gateway-table.popupmenu.log' | translate}}
    </a>

    <button mat-menu-item (click)="openChangeDialog(gw.gatewaySerial, gw.tenant, gw.location)">
      <mat-icon>edit</mat-icon>
      {{'gateway-table.popupmenu.edit' | translate}}
    </button>

    <button mat-menu-item (click)="openGatewayConfig(gw.gatewaySerial)">
      <mat-icon>settings</mat-icon>
      {{'gateway-table.popupmenu.config' | translate}}
    </button>

    <button mat-menu-item (click)="openDeletionDialog(gw.gatewaySerial)">
      <mat-icon svgIcon="eon-trash-bin"></mat-icon>
      {{'gateway-table.popupmenu.delete' | translate}}
    </button>

  </ng-template>
</mat-menu>


